<template>
  <div class="service-box"
       :class="[classes, {'service-box-img': img, 'hide-cursor': showMoreIcon}, `grid-item-${clasItem + 1}`]"
       @click="openModal({ name, img, description, initials })"
       @mouseover="moveMoreIcon"
       @mousemove="moveMoreIcon"
       @mouseleave="showMoreIcon = false" >
    <div class="service-box-inside">
      <template v-if="clasItem == 2">
          <div class="dashed dashed-left"></div>
          <div class="dashed dashed-right"></div>
      </template>
      <!-- <template v-if="clasItem == 3">
      </template> -->
      <div class="service-box-info-container d-flex flex-column">
        <!-- <figure v-if="img">
          <img :src="require('../' + img)" alt="" />
        </figure> -->
        <h2 class="bcLiguria" v-if="initials">{{ initials }}</h2>
        <h4 class="bcLiguria">{{name}}</h4>
        <!-- <div class="arrow-container" v-if="linkTo">
          <ArrowIcon></ArrowIcon>
        </div> -->
      </div>
    </div>
    <MoreIcon class="more-icon" v-if="showMoreIcon && initials" :style="{ left: moreIconPos.left, top: moreIconPos.top }"></MoreIcon>
  </div>
</template>

<script>
// import '../../public/pixel-canvas.js'
// import ArrowIcon from '../assets/img/arrow-icon.svg'
import MoreIcon from '@/assets/img/more-icon.svg'
export default {
  name: 'HomeService',
  props: ['name', 'description', 'img', 'classes', 'clasItem', 'initials'],
  components: {
    MoreIcon
  },
  // components: {
  //   ArrowIcon
  // },
  data () {
    return {
      showFullDescription: false,
      showMoreIcon: false,
      moreIconPos: { left: 0, top: 0 }
    }
  },
  methods: {
    openModal (service) {
      if (!this.initials) return // Evita abrir el modal si initials está vacío o null
      this.$emit('open-modal', service)
    },
    moveMoreIcon (event) {
      if (!this.showMoreIcon) {
        this.showMoreIcon = true // Activa el icono inmediatamente
      }
      const parentRect = event.currentTarget.getBoundingClientRect()
      const iconSize = 50 // Ajusta esto si el icono tiene otro tamaño

      const x = event.clientX - parentRect.left - (iconSize / 2)
      const y = event.clientY - parentRect.top - (iconSize / 2)

      requestAnimationFrame(() => {
        this.moreIconPos = { left: `${x}px`, top: `${y}px` }
      })
    }
  }

}
</script>

<style scoped lang="scss">
.service-box {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: calc(calc(100vw - 80px - calc(14px * 5) - 14px) / 6);
  aspect-ratio: 1;
  font-size: 100%;
  z-index: 10;
  @include backgroundTransparency(#000, 1);
  // &:hover {
  //   cursor: pointer;
  // }
  &.hide-cursor {
    cursor: none !important;
  }
  // .pixel-canvas{
  //   position: absolute;
  //   width: 100%;
  //   height: 100%;
  //   z-index: 0;
  //   opacity: 0.5;
  // }
  .dashed{
      width: 140px;
      height: 2px;
      background-color: #000;
      position: absolute;
      z-index: 100;
      opacity: 0;
  }
  .dashed-left{
      left: -70px;
      bottom: -71px;
      rotate: -45deg;
      transform-origin: bottom left;
  }
  .dashed-right{
      right: -70px;
      bottom: -71px;
      rotate: 45deg;
      transform-origin: bottom right;
  }
  .service-box-inside {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    mix-blend-mode: difference;
    pointer-events: none;
  }
  .service-box-info-container {
    // margin: var(--main-space);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    font-size: 100%;
    figure {
      margin: 0;
      margin-top: calc(-1 * var(--main-space));
      height: 200px;
      margin-bottom: var(--main-space);
      img {
        width: 100%;
        @supports (object-fit: cover) {
          object-fit: cover;
          object-position: center;
          height: 100%;
        }
      }
    }
    h2{
      font-size: 124px;
      color: #8C9091;
      margin-bottom: -8px;
    }
    h4 {
      font-size: 18px;
      color: #8C9091;
    }
  }

  &.height-auto {
    .service-box-info-container {
      p {
        -webkit-line-clamp: inherit;
      }
    }
  }

  &.benefit-box-stacbond {
    h4 {
      text-align: center;
      font-size: 18px;
    }
  }

  .more-icon {
    width: 50px;
    height: 50px;
    fill: #FFF;
    position: absolute;
    transition: transform 0.1s ease-out;
    pointer-events: none;
    cursor: none;
  }
}
.grid-item-2{
      grid-column-start: 2;
      grid-row-start: 2;
      border-radius: 200px;
      overflow: hidden;
      &:hover {
        cursor: inherit!important;
      }
      .service-box-inside{
        h4{
          text-transform: uppercase;
        }
      }
  }
  .grid-item-3{
      grid-column-start: 3;
  }
  .grid-item-4{
      grid-column-start: 4;
      grid-row-start: 2;
      border-radius: 200px;
      overflow: hidden;
      &:hover {
        cursor: inherit!important;
      }
      .service-box-inside{
        h4{
          text-transform: uppercase;
        }
      }
  }
  .grid-item-5{
      grid-column-start: 7;
      grid-row-start: 1;
  }
  .grid-item-6{
      grid-column-start: 6;
      grid-row-start: 1;
  }
@media (max-width: 1024px){
  .service-box{
    //  min-width: 120px;
     width: 220px!important;
     .dashed{
        opacity: 1;
     }
  }
}
</style>
